import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { MSAL_INSTANCE, MsalService, MsalGuard, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { routes } from './app/app.routes';
import { msalConfig } from './msal-config';

export function MSALInstanceFactory() {
  return new PublicClientApplication(msalConfig);
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect, // Redirect
    authRequest: {
      scopes: ['user.read']
    }
  };
}

async function main() {
  const msalInstance = new PublicClientApplication(msalConfig);
  await msalInstance.initialize();

  bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [
      provideZoneChangeDetection(),...(appConfig.providers || []),
      {
        provide: MSAL_INSTANCE,
        useValue: msalInstance
      },
      {
        provide: MSAL_GUARD_CONFIG,
        useFactory: MSALGuardConfigFactory
      },
      provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })),
      MsalService,
      MsalGuard,
      MsalBroadcastService
    ]
  }).catch((err) => console.error(err));
}

main();